import { render, staticRenderFns } from "./feedBait_task_page.vue?vue&type=template&id=a041726a&scoped=true"
import script from "./feedBait_task_page.vue?vue&type=script&lang=js"
export * from "./feedBait_task_page.vue?vue&type=script&lang=js"
import style0 from "./feedBait_task_page.vue?vue&type=style&index=0&id=a041726a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a041726a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a041726a')) {
      api.createRecord('a041726a', component.options)
    } else {
      api.reload('a041726a', component.options)
    }
    module.hot.accept("./feedBait_task_page.vue?vue&type=template&id=a041726a&scoped=true", function () {
      api.rerender('a041726a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_task_page.vue"
export default component.exports